export default function ListItem({ children }) {
  return <li className="leading-loose pl-6 relative">{children}</li>;
}
